import React from 'react';
import { Container } from 'react-bootstrap';
import { useScrollAnimation } from '../hooks/useScrollAnimation';

const Screenshots = () => {
  const { ref, inView } = useScrollAnimation({ threshold: 0.2 });

  const screenshots = [
    { src: '/images/screenshots/screenshot-1.png', alt: 'Cycle tracking dashboard' },
    { src: '/images/screenshots/screenshot-2.png', alt: 'Prayer times and tracking' },
    { src: '/images/screenshots/screenshot-3.png', alt: 'Period journal and insights' },
    { src: '/images/screenshots/screenshot-4.png', alt: 'Fasting and Qada tracker' },
    { src: '/images/screenshots/screenshot-5.png', alt: 'Dua and guidance library' },
    { src: '/images/screenshots/screenshot-6.png', alt: 'Habits and wellness tracker' },
    { src: '/images/screenshots/screenshot-7.png', alt: 'Community and support' },
    { src: '/images/screenshots/screenshot-8.png', alt: 'Profile and settings' },
  ];

  return (
    <section id="screenshots" className="screenshots-section" ref={ref}>
      <div className={`animate-on-scroll fade-in-up ${inView ? 'visible' : ''}`}>
        <Container>
          <h2 className="screenshots-title text-center">See Nisa Care in Action</h2>
          <p className="screenshots-subtitle text-center">
            Beautiful, intuitive screens designed for your spiritual and menstrual wellness journey
          </p>

          <div className="screenshots-grid">
            {screenshots.map((screenshot, index) => (
              <div key={index} className="screenshot-item">
                <div className="screenshot-frame">
                  <img 
                    src={screenshot.src} 
                    alt={screenshot.alt}
                    loading="lazy"
                  />
                </div>
              </div>
            ))}
          </div>
        </Container>
      </div>
    </section>
  );
};

export default Screenshots;